/* Sara Elmsalati — smooth scroll (Lenis) + scroll reveals (GSAP).
   Robust by design:
   - Reveals are triggered by IntersectionObserver, so an element is only ever
     hidden while off-screen; it reveals the moment it could become visible.
     Content can never get permanently stuck invisible.
   - Lenis + reveals are skipped in the Shopify theme editor (design mode) and
     under prefers-reduced-motion, where smooth-scroll libraries misbehave.
   - Everything is guarded so a failure leaves content fully visible. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var lenis = null;

  /* ---------------- Lenis smooth scroll ---------------- */
  function startLenis() {
    if (reduce || designMode || typeof Lenis === 'undefined') return;
    try {
      lenis = new Lenis({
        duration: 1.1,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true,
        touchMultiplier: 1.6
      });
    } catch (e) { lenis = null; return; }
    window.__lenis = lenis;
    function raf(time) { if (lenis) { lenis.raf(time); requestAnimationFrame(raf); } }
    requestAnimationFrame(raf);
  }

  /* ---------------- Smooth anchor scrolling ---------------- */
  function anchorScroll(e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.site-header');
    var offset = header ? header.offsetHeight : 0;
    if (lenis) {
      lenis.scrollTo(target, { offset: -offset, duration: 1.2 });
    } else {
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  /* ---------------- GSAP reveals (IntersectionObserver-driven) ---------------- */
  var SINGLES = [
    ['.section-title', 24],
    ['.about-text', 26],
    ['.about-grid image-slot', 30],
    ['.imgdir-card', 26],
    ['.contact-form', 26],
    ['.edu-tabs', 26],
    ['.edu-card', 20]
  ];
  var GROUPS = [
    ['.cards-grid', '.service-card'],
    ['.gallery-grid', '.gallery-card'],
    ['.imgdir-strip', 'image-slot']
  ];
  var io = null;

  function revealsEnabled() {
    return !reduce && !designMode && window.gsap && ('IntersectionObserver' in window);
  }

  function getObserver() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        if (el.__staggerItems) {
          gsap.to(el.__staggerItems, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', stagger: 0.12 });
        } else {
          gsap.to(el, { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' });
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function setupReveals(root) {
    if (!revealsEnabled() || !root.querySelectorAll) return;
    var obs = getObserver();

    SINGLES.forEach(function (s) {
      root.querySelectorAll(s[0]).forEach(function (el) {
        if (el.__rev) return;
        el.__rev = true;
        gsap.set(el, { opacity: 0, y: s[1] });
        obs.observe(el);
      });
    });

    GROUPS.forEach(function (g) {
      root.querySelectorAll(g[0]).forEach(function (container) {
        if (container.__rev) return;
        var items = container.querySelectorAll(g[1]);
        if (!items.length) return;
        container.__rev = true;
        gsap.set(items, { opacity: 0, y: 28 });
        container.__staggerItems = items;
        obs.observe(container);
      });
    });

    var hero = root.querySelector('.hero-title');
    if (hero && !hero.__rev) {
      hero.__rev = true;
      gsap.fromTo(hero, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out', delay: 0.15 });
    }
  }

  /* ---------------- Boot ---------------- */
  function init() {
    startLenis();
    document.addEventListener('click', anchorScroll);
    try { setupReveals(document); } catch (e) { /* leave content visible */ }
    document.addEventListener('shopify:section:load', function (e) {
      try { setupReveals(e.target); } catch (err) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
